import React from 'react';
import { FileInput, FileField, useTranslate } from 'react-admin';
import { Typography, Box } from '@mui/material';
import PropTypes from 'prop-types';
import ImportIcon from '@/assets/icons/import-icon.svg?react';
import ImportLoadingIcon from '@/assets/icons/loading-icon.svg?react';
import { styled } from '@mui/material/styles';
import { importInputBaseStyles } from '@/themes/commonStyles';

const StyledImportFileInput = styled(Box)(importInputBaseStyles);

const ImportFileInput = ({
    source = 'file',
    accept = '.csv',
    validate,
    placeholderText,
    loading = false,
    disabled = false,
    onFileChange,
    fullWidth = false,
}) => {
    const translate = useTranslate();
    const placeholder = loading ? translate('resources.campaign.labels.verifyingFile') : translate('resources.campaign.labels.chooseFile');

    const handleFileInputChange = value => {
        if (onFileChange) {
            onFileChange(value);
        }
    };

    return (
        <StyledImportFileInput sx={{ width: fullWidth ? '100%' : 'auto' }}>
            <FileInput
                source={source}
                accept={accept}
                validate={validate}
                disabled={disabled}
                onChange={handleFileInputChange}
                placeholder={
                    <div className='import-info'>
                        <Typography variant='body1'>{placeholderText}</Typography>
                        <Typography variant='body1' className={`btn-import ${loading ? 'loading' : 'loaded'}`} disabled={loading}>
                            {loading && <ImportLoadingIcon />}
                            {!loading && <ImportIcon />}
                            {placeholder}
                        </Typography>
                    </div>
                }
            >
                <FileField source='src' title='title' disabled={disabled} />
            </FileInput>
        </StyledImportFileInput>
    );
};

ImportFileInput.propTypes = {
    source: PropTypes.string,
    accept: PropTypes.string,
    validate: PropTypes.func,
    placeholderText: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    onFileChange: PropTypes.func,
    fullWidth: PropTypes.bool,
};

export default ImportFileInput;
